import { getBookingsStatuses } from 'store/v1/statuses/statuses.selectors';
import { buildAssignWithStatus } from './buildAssignWithStatus';
import { useDispatch, useSelector } from 'react-redux';
import { createBookingObject } from 'v1/helpers/byModel/BookingHelper.js';
import get from 'lodash/get.js';
import { createNewEventObject } from 'v1/helpers/byModel/EventHelper.js';
import {
  createBooking,
  updateBooking
} from 'store/v1/bookings/bookings.actions.js';

export function useResourceAssignWithStatus() {
  const bookingStatuses = useSelector(getBookingsStatuses);
  const dispatch = useDispatch();
  const bookingTypes = useSelector(state => state.booking_types);

  return {
    buildAssignWithStatus: ({ booking, resource, slot, production }) => {
      function updateBookingWithAssignment() {
        const existingAssignments = get(
          booking,
          'resource_slot_assignments',
          []
        );
        const resourceId = resource?.id;
        const resourceSlotId = slot?.id;

        // Check if there's already an assignment for this resource and slot combination
        const existingAssignment = existingAssignments.find(
          assignment =>
            assignment.contact_id === resourceId &&
            assignment.resource_slot_id === resourceSlotId
        );

        // If assignment already exists, return booking without modification
        if (existingAssignment) {
          return booking;
        }

        return {
          ...booking,
          resource_slot_assignments: [
            ...existingAssignments,
            {
              contact_id: resourceId,
              resource_slot_id: resourceSlotId,
              events: [
                createNewEventObject({
                  ...production.production_date,
                  event_type: 'RESOURCE_SLOT_ASSIGNMENT'
                })
              ]
            }
          ]
        };
      }
      return buildAssignWithStatus({
        booking,
        resource,
        slot,
        production,
        statusesList: bookingStatuses,
        onStatusUpdate: ({ status, booking, resource, slot, production }) => {
          // Handle status update with the selected status
          if (booking && bookingHasAssignments(booking)) {
            // Update booking with assignment and new status
            dispatch(
              updateBooking(booking.id, {
                ...updateBookingWithAssignment(),
                status_id: status.id
              })
            );
          } else {
            // Create new booking with selected status
            const newBooking = createBookingObject(bookingTypes, {
              event: get(production, 'production_date', null),
              resource: resource,
              slot: slot,
              status: status
            });
            dispatch(createBooking(newBooking));
          }
        }
      });
    }
  };
}

function bookingHasAssignments(booking) {
  return (
    booking &&
    booking.resource_slot_assignments &&
    booking.resource_slot_assignments.length
  );
}
